import { action } from 'mobx';
import { ClassesService } from 'modules/content';
import {
  DeepSearchService,
  DeepSearchStore as Store
} from 'modules/userManager';

class DeepSearchContentService {
  filterCount = 'contentFilterCount';
  filter = 'contentFilter';
  maxRange = {
    min: 0,
    max: 100
  };

  @action
  updateStoreRangeValues = (field, min, max) => {
    const filter = Store.getFilter(this.filter, field);

    filter.min = min;
    filter.max = max;

    const isOnMaxRange = min === this.maxRange.min && max === this.maxRange.max;
    const isUpdateCount = !isOnMaxRange && filter.queryData;
    const notUpdateCount = isOnMaxRange && !filter.queryData;

    this.updateStoreCount(isUpdateCount, notUpdateCount, field);
  };

  @action
  updateStoreContentSelect = (field, ids) => {
    const filter = Store.getFilter(this.filter, field);
    const currentId = filter.ids[0];

    if (currentId !== ids[0]) {
      Store.getFilter(this.filter, field).ids = ids;

      const isUpdateCount = filter.ids.length;
      const updateCountCheck = !currentId || ids.length === 0;

      updateCountCheck &&
        this.updateStoreCount(isUpdateCount, !isUpdateCount, field);
    }
  };

  @action
  updateStoreQuiz = (field, selectedOption) => {
    const currentId = Store.getFilter(this.filter, field).id;

    if (selectedOption === null) {
      Store.getFilter(this.filter, field).id = '';
      this.updateStoreCount(false, true, field);
    } else if (currentId !== selectedOption.id) {
      Store.getFilter(this.filter, field).id = selectedOption.id;
      currentId === '' &&
        this.updateStoreCount(selectedOption.id, !selectedOption.id, field);
    }
  };

  @action
  updateStoreProfile = (field, profileId) => {
    Store.getFilter(this.filter, field).profileId = profileId;
  };

  @action
  updateStoreQuizScore = (field, value) => {
    Store.deepSearch.contentFilter[field] = {
      ...Store.getFilter(this.filter, field),
      ...value
    };

    const filter = Store.getFilter(this.filter, field);
    const isUpdateCount = filter.ids.length && filter.queryData;
    const notUpdateCount = !filter.ids.length && !filter.queryData;

    this.updateStoreCount(isUpdateCount, notUpdateCount, field);
  };

  @action
  updateStorePage = (field, value) => {
    const { contentFilter } = Store.deepSearch;
    const { page, incompletePage } = contentFilter;
    const oldLength = page.ids.length + incompletePage.ids.length;

    Store.deepSearch.contentFilter[field] = {
      ...Store.getFilter(this.filter, field),
      ...value
    };

    const { contentFilter: newContentFilter } = Store.deepSearch;
    const { page: newPage, incompletePage: newIncompletePage } =
      newContentFilter;
    const newLength = newPage.ids.length + newIncompletePage.ids.length;

    if (oldLength === 0 && newLength > 0) {
      DeepSearchService.updateFilterCount(true, false, this.filterCount);
    } else if (oldLength > 0 && newLength === 0) {
      DeepSearchService.updateFilterCount(false, true, this.filterCount);
    }
  };

  @action
  updateStoreCount = (isUpdateCount, notUpdateCount, field) => {
    let countValue = false;

    if (isUpdateCount) {
      countValue = true;
      Store.getFilter(this.filter, field).queryData = false;
    } else if (notUpdateCount) {
      Store.getFilter(this.filter, field).queryData = true;
    }

    DeepSearchService.updateFilterCount(
      countValue,
      Store.getFilter(this.filter, field).queryData,
      this.filterCount
    );
  };

  normalizeModulesTreeDate = (modulesTree) =>
    modulesTree.map((module) => {
      module.pages = module.pages.map((page) => ({
        ...page,
        value: page.id,
        checked: false
      }));
      module.value = module.id;
      module.checked = false;

      return module;
    });

  quizzesFormatted = (quizzesExerciseList) =>
    quizzesExerciseList.map((item) => ({
      ...item,
      labelValue: item.name,
      checked: false
    }));

  @action
  normalizeQuizzesData = (quizzesList) =>
    quizzesList.map((quiz) => ({
      ...quiz,
      value: quiz.id,
      label: quiz.name
    }));

  @action
  getProfileValue = (selectedOption) =>
    selectedOption ? selectedOption.value : '';

  @action
  getUserClassIds = (selectedOption) =>
    selectedOption ? [selectedOption.value] : [];

  @action
  getListsData = async () => {
    const classesList = await ClassesService.getSelectFormatedClasses();
    const modulesTree = await DeepSearchService.getAllModulesTree();
    const quizzesExercise = await DeepSearchService.getAllQuizzesExercise();
    const quizzesProfile = await DeepSearchService.getAllQuizzesProfile();

    const quizzesExerciseList = this.quizzesFormatted(
      this.normalizeQuizzesData(quizzesExercise)
    );
    const quizzesProfileList = this.normalizeQuizzesData(quizzesProfile);
    const modulesTreeList = this.normalizeModulesTreeDate(modulesTree);

    const firstIndex = 0;
    const userClassSelected = classesList.find((classObj) => {
      const userClassIds = Store.getFilter(this.filter, 'userClass').ids;

      return (
        classObj.value === (userClassIds.length && userClassIds[firstIndex])
      );
    });
    const quizProfileSelected = quizzesProfileList.find(
      (quiz) => quiz.id === Store.getFilter(this.filter, 'quizProfile').id
    );

    return {
      quizProfileSelected,
      classesList,
      quizzesExerciseList,
      quizzesProfileList,
      modulesTreeList,
      userClassSelected
    };
  };
}

export default new DeepSearchContentService();
